import React from "react";
import SensorBase from "./SensorBase";
import IrrigationHour from "../../../components/IrrigationHour";

const FIELD = "moisture2";
const UNIT = "%";

const Moisture2: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT}></SensorBase>
      <IrrigationHour />
    </div>
  );
};

export default Moisture2;
